import { connect } from 'react-redux';

import {
  subscribeToVisibleBoardgames,
  unsubscribeToVisibleBoardgames,
  reserveBoardgame,
  getBackBoardgame,
  getBackAllBoardgames,
} from '../actions/boardgames';

import { getCategories } from '../actions/categories';

import {
  visibleBoardgamesWithoutReservationSelector,
  visibleReservedBoardgamesSelector,
  maxNumberOfPlayersSelector,
  loadingSelector,
  getBackAllBoardgamesButtonEnabledSelector,
} from '../reducers/boardgames';

import AdminBoardgamesListNightPageComponent from '../components/AdminBoardgamesListNightPage';

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    boardgames: visibleBoardgamesWithoutReservationSelector(state),
    boardgamesWithReservation: visibleReservedBoardgamesSelector(state),
    maxNumberOfPlayers: maxNumberOfPlayersSelector(state),
    loading: loadingSelector(state),
    isGetBackAllBoardgamesButtonEnabled: getBackAllBoardgamesButtonEnabledSelector(state),
  };
};

const mapDispatchToProps = dispatch => {
  return { 
    getVisibleBoardgames: (orderBy) => dispatch(subscribeToVisibleBoardgames(orderBy)),
    unsubscribeToVisibleBoardgames: () => dispatch(unsubscribeToVisibleBoardgames()),
    getCategories: () => dispatch(getCategories()),
    reserveBoardgame: (id) => dispatch(reserveBoardgame(id)),
    getBackBoardgame: (id) => dispatch(getBackBoardgame(id)),
    getBackAllBoardgames: (ids) => dispatch(getBackAllBoardgames(ids)),
  };
};

const AdminBoardgamesListNightPage = connect(mapStateToProps, mapDispatchToProps)(AdminBoardgamesListNightPageComponent);

export default AdminBoardgamesListNightPage;

